import React from 'react';
import type { Maybe } from '.tina/__generated__/types';
import list from 'public/asset_list.json';
import styled, { css } from 'styled-components';

interface TinaVideo {
  src: Maybe<string> | undefined;
  poster?: Maybe<{
    src?: Maybe<string>;
    priority?: Maybe<boolean>;
    width?: Maybe<number>;
    height?: Maybe<number>;
    alt?: Maybe<string>;
    horizontalPadding?: Maybe<boolean>;
    maxHeightMobile?: Maybe<boolean>;
  }>;
  fit?: string;
}

interface TinaVideoStyles {
  mobileborderradius?: number;
  desktopborderradius?: number;
  $horizontalPaddingMobile?: boolean;
  poster?: Maybe<string>;
}
/* desktop only need >= 0, cause if not we would simply take the border radius from mobile.
Mobile doesn't need it, since if you set mobile to 0, it reads as false and doesnt add border-radius */
const Video = styled.video<TinaVideoStyles>`
  width: 100%;
  height: 100%;
  object-fit: cover;
  padding: ${({ $horizontalPaddingMobile }) => $horizontalPaddingMobile && '0 1.5rem'};
  ${({ theme }) => theme.mq.md`
    padding: 0;
  `}
  ${({ theme: { mq }, mobileborderradius, desktopborderradius }) =>
    css`
      ${`border-radius: ${mobileborderradius || 16}px;`}
      ${mq.md`
        border-radius: ${desktopborderradius || 24}px;
      `}
    `}
`;

const TinaVideo: React.FC<TinaVideo> = ({ src, poster, ...props }) => {
  if (!src) {
    return null;
  }
  // @ts-ignore
  const meta = list.index[src];
  if (!meta) {
    console.log('run asset meta generator');
  }

  return (
    <Video
      autoPlay
      loop
      playsInline
      muted
      width={meta.width}
      height={meta.height}
      poster={poster?.src || undefined}
      {...props}
    >
      <source src={src} />
    </Video>
  );
};

export default TinaVideo;
